import { useMutation } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import type { components } from "@/api/generated/schema";

type PlatformScaleReading = components["schemas"]["PlatformScaleReading"];
type OilTankReading = components["schemas"]["OilTankReading"];

// openapi-fetch handles multipart when body is FormData, but openapi-typescript
// types the body as the form shape — cast through unknown so the serializer
// sees the real FormData object.
async function postPhotoFile<T>(
  path: "/api/scale-ocr/platform" | "/api/scale-ocr/oil",
  file: File,
  errorMsg: string,
): Promise<T> {
  const formData = new FormData();
  formData.append("file", file);
  const result = await api.POST(path, {
    body: formData as never,
    bodySerializer: (b: unknown) => b as FormData,
  });
  return throwIfError(result, errorMsg) as T;
}

export function useReadPlatformPhoto() {
  return useMutation<PlatformScaleReading, Error, File>({
    mutationFn: (file) => postPhotoFile("/api/scale-ocr/platform", file, "Failed to read scale photo"),
  });
}

export function useReadOilPhoto() {
  return useMutation<OilTankReading, Error, File>({
    mutationFn: (file) => postPhotoFile("/api/scale-ocr/oil", file, "Failed to read the MD4 photo"),
  });
}
